import { render, staticRenderFns } from "./FreeDashBoard.vue?vue&type=template&id=43904b74&scoped=true"
import script from "./FreeDashBoard.vue?vue&type=script&lang=js"
export * from "./FreeDashBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43904b74",
  null
  
)

export default component.exports